import React, { useContext, useEffect, useState } from "react";

const Charm = () => {
  return (
    <div>
      <img
        src="img/charm.jpg"
        alt="Full Width"
        style={{ width: "100%", height: "auto", display: "block" }}
      />
    </div>

  );
};

export default Charm;